import { useNavigate } from "react-router-dom";

import {
  Container,
  Grid2 as Grid,
  Grid2Props as GridProps,
} from "@mui/material";

import { Center, Text } from "@mantine/core";

import AnimateOnLoad from "../../Components/AnimateOnLoad";

import { RouteList } from "../../Lib/routes";
import "./styles.scss";
import { useContext } from "react";
import { AppContext } from "../Dashboard";
import MegaLoader from "../../Components/MegaLoader";

export default function Overview() {
  const navigate = useNavigate();
  const context = useContext(AppContext);
  const gridItemProps: GridProps = {
    className: "item",
    size: {
      xl: 2.4,
      lg: 2.4,
      md: 3,
      sm: 4,
      xs: 6,
    },
  };
  const scopes = context?.profile?.scopes ?? [];
  const routes =
    context?.profile?.role === "superadmin"
      ? RouteList
      : RouteList.filter((route) => {
          return route.scopes.some((scope) => scopes.includes(scope));
        });
  return (
    <AnimateOnLoad>
      <div className="overview-container flex-row justify-center width-100">
        <Container maxWidth="lg">
          <div className="component-header">
            <Text className="label" tt="capitalize">
              Overview
            </Text>
          </div>
          <br />
          {context?.isLoadingProfile ? (
            <Center w="100%">
              <MegaLoader />
            </Center>
          ) : (
            <Grid container className="items">
              {routes.map((route) => {
                return (
                  <Grid
                    key={route.label}
                    {...gridItemProps}
                    // @ts-ignore
                    onClick={() => {
                      navigate(`${route.path}`);
                    }}
                  >
                    <route.icon
                      size={40}
                      stroke={1.2}
                      color="var(--purple-primary)"
                    />
                    <Text className="label">{route.label}</Text>
                  </Grid>
                );
              })}
            </Grid>
          )}
        </Container>
      </div>
    </AnimateOnLoad>
  );
}
